import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { I18nService } from '@core/services/i18n.service';
import { environment } from '@env/environment';
import { TranslocoService } from '@ngneat/transloco';
import { LanguageModel } from '@shared/models/language.model';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageComponent implements OnInit {

  selectedLang = this.translocoService.getActiveLang();
  langs: LanguageModel[] = environment.availableLangs.map(o => {
    o.value = o.id;
    return o;
  });

  constructor(private translocoService: TranslocoService, private langService: I18nService) { }

  ngOnInit(): void { }

  /**
   * change langugage
   * @param {string} value
   */
  changeLang(value: string): void {
    this.langService.language = value;
  }
}
